import React from 'react';
import { Activity } from 'lucide-react';

export default function PortalHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Portal Utama</h1>
        <p className="text-gray-500 mt-1">Selamat datang di Sistem Modular Bank</p>
      </div>
      <div className="flex items-center gap-2">
        <span className="inline-flex items-center gap-1 px-2.5 py-0.5 border border-gray-300 text-gray-700 text-xs font-medium rounded-full">
          <Activity className="w-3 h-3" />
          Sistem Aktif
        </span>
      </div>
    </div>
  );
}
